import { useEffect, useState } from "react";
import {
  assetUrl,
  authRequestNbGet,
  formatDate,
  formatDMy,
} from "../../utils/helpers";

const TourCard = ({ tour, upcoming = false }) => {
  if (!tour) return null;

  const requiredPoints = Number(tour?.required_points || 0);

  const requiredValidators = Number(tour?.direct_team_validators || 0);

  return (
    <div className="col-6 col-lg-3">
      <div className="sntravel">
        {/* IMAGE */}
        <div className="TImg">
          {tour?.banner_image ? (
            <img
              src={`${assetUrl}${tour.banner_image}`}
              className="img-fluid w-100"
              alt={tour?.title || "Tour"}
              onError={(e) => {
                e.currentTarget.style.display = "none";
              }}
            />
          ) : (
            <div
              className="d-flex align-items-center justify-content-center bg-light"
              style={{
                minHeight: "180px",
              }}
            >
              <span className="text-muted">No Image</span>
            </div>
          )}
        </div>

        {/* CONTENT */}
        <div className="content">
          {/* TITLE */}
          <div className="tourTitleRow mb-2">
            <h4>{tour?.title || "Tour"}</h4>
          </div>

          {/* TOUR DATE */}
          <div className="tourMeta">
            <div className="tourMetaItem">
              <span className="tourMetaIcon">
                <i className="fa-regular fa-calendar"></i>
              </span>

              <div className="tourMetaText">
                <small>{upcoming ? "Tour Schedule" : "Tour Date"}</small>

                <strong>
                  {tour?.tour_month_date
                    ? formatDate(tour.tour_month_date)
                    : "Date not available"}
                </strong>
              </div>
            </div>
          </div>

          <div className="tourMeta">
            <div className="tourMetaItem">
              <span className="tourMetaIcon">
                <i className="fa-solid fa-calendar-check"></i>
              </span>
              <div>
                <small>Booking Till</small>
                <strong>
                  {formatDMy(tour.last_application_date)}{" "}
                  {/* {tour.end_date
                                            ? `- ${formatDate(tour.end_date)}`
                                            : ""} */}
                </strong>
              </div>
            </div>
          </div>

          <div className="tourMeta">
            <div className="tourMetaItem">
              <span className="tourMetaIcon">
                <i className="fa-solid fa-location-dot"></i>
              </span>

              <div className="tourMetaText">
                <strong>{tour?.country || "Location not available"}</strong>
              </div>
            </div>
          </div>

          {/* UPCOMING TOUR QUALIFICATION */}
          {upcoming && (
            <div className="tourEligibility">
              <i className="fa-solid fa-award"></i>

              <span>
                Required:{" "}
                <strong>
                  {requiredPoints > 0 && (
                    <>
                      {requiredPoints} <i className="fa-solid fa-gem"></i>
                    </>
                  )}

                  {requiredPoints > 0 && requiredValidators > 0 && <> / </>}

                  {requiredValidators > 0 && (
                    <>
                      {requiredValidators}{" "}
                      <i className="fa-solid fa-user-check"></i>
                    </>
                  )}

                  {requiredPoints <= 0 && requiredValidators <= 0 && (
                    <>Not configured</>
                  )}
                </strong>
              </span>
            </div>
          )}

          {/* DESTINATIONS */}
          {upcoming && tour?.destinations && (
            <div className="tourDestinations">
              <i className="fa-solid fa-route"></i>

              <span>{tour.destinations}</span>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

/* LOADING CARD */

const TourCardSkeleton = () => {
  return (
    <div className="col-6 col-lg-3">
      <div className="sntravel">
        <div
          className="placeholder-glow bg-light"
          style={{
            height: "180px",
            borderRadius: "10px",
          }}
        >
          <span className="placeholder col-12 h-100"></span>
        </div>

        <div className="content mt-3">
          <p className="placeholder-glow">
            <span className="placeholder col-8"></span>
          </p>

          <p className="placeholder-glow">
            <span className="placeholder col-6"></span>
          </p>

          <p className="placeholder-glow">
            <span className="placeholder col-5"></span>
          </p>
        </div>
      </div>
    </div>
  );
};

/* MAIN COMPONENT */

const TravelTours = () => {
  const [upcomingTours, setUpcomingTours] = useState([]);

  const [completeTours, setCompleteTours] = useState([]);

  const [upcomingLoading, setUpcomingLoading] = useState(true);

  const [completedLoading, setCompletedLoading] = useState(true);

  const [upcomingError, setUpcomingError] = useState("");

  const [completedError, setCompletedError] = useState("");

  useEffect(() => {
    getUpcomingTours();
    getCompletedTours();
  }, []);

  const getUpcomingTours = async () => {
    setUpcomingLoading(true);
    setUpcomingError("");

    try {
      const res = await authRequestNbGet("/home/tours/upcoming");

      if (res?.status === 200 || res?.message === "OK") {
        setUpcomingTours(Array.isArray(res?.data) ? res.data : []);
      } else {
        setUpcomingTours([]);

        setUpcomingError(res?.message || "Unable to load upcoming tours.");
      }
    } catch (error) {
      console.error("Upcoming tours error:", error);

      setUpcomingTours([]);

      setUpcomingError("Unable to load upcoming tours.");
    } finally {
      setUpcomingLoading(false);
    }
  };

  const getCompletedTours = async () => {
    setCompletedLoading(true);
    setCompletedError("");

    try {
      const res = await authRequestNbGet("/home/tours/past");

      if (res?.status === 200 || res?.message === "OK") {
        setCompleteTours(Array.isArray(res?.data) ? res.data : []);
      } else {
        setCompleteTours([]);

        setCompletedError(res?.message || "Unable to load completed tours.");
      }
    } catch (error) {
      console.error("Completed tours error:", error);

      setCompleteTours([]);

      setCompletedError("Unable to load completed tours.");
    } finally {
      setCompletedLoading(false);
    }
  };

  return (
    <section className="travelPartSec padSec">
      <div className="container">
        {/* UPCOMING TOURS */}

        <div className="travelHeader">
          <div>
            <span className="travelEyebrow">TRUST BITCOIN TRAVEL</span>

            <h2>
              Upcoming <span>Tours</span>
            </h2>

            <p>
              Discover our upcoming international travel experiences and
              destinations.
            </p>
          </div>

          <a href="/upcoming-tours" className="tourViewAll">
            View All
            <i className="fa-solid fa-arrow-right"></i>
          </a>
        </div>

        <div className="row matchHeight g-3 mb-5">
          {upcomingLoading ? (
            <>
              {[1, 2, 3, 4].map((item) => (
                <TourCardSkeleton key={`upcoming-loading-${item}`} />
              ))}
            </>
          ) : upcomingError ? (
            <div className="col-12">
              <div className="alert alert-danger">
                {upcomingError}

                <button
                  type="button"
                  className="btn btn-link p-0 ms-2"
                  onClick={getUpcomingTours}
                >
                  Retry
                </button>
              </div>
            </div>
          ) : upcomingTours.length > 0 ? (
            upcomingTours.map((tour, index) => (
              <TourCard
                key={tour?.id || `upcoming-${index}`}
                tour={tour}
                upcoming={true}
              />
            ))
          ) : (
            <div className="col-12">
              <p className="text-muted">No upcoming tours available.</p>
            </div>
          )}
        </div>

        {/* COMPLETED TOURS */}

        <div className="travelHeader completedHeader">
          <div>
            <span className="travelEyebrow">OUR JOURNEY</span>

            <h2>
              Completed <span>Tours</span>
            </h2>

            <p>
              Explore the international tours and unforgettable experiences
              completed by our community.
            </p>
          </div>

          <a href="/completed-tours" className="tourViewAll">
            View All
            <i className="fa-solid fa-arrow-right"></i>
          </a>
        </div>

        <div className="row matchHeight g-3">
          {completedLoading ? (
            <>
              {[1, 2, 3, 4].map((item) => (
                <TourCardSkeleton key={`completed-loading-${item}`} />
              ))}
            </>
          ) : completedError ? (
            <div className="col-12">
              <div className="alert alert-danger">
                {completedError}

                <button
                  type="button"
                  className="btn btn-link p-0 ms-2"
                  onClick={getCompletedTours}
                >
                  Retry
                </button>
              </div>
            </div>
          ) : completeTours.length > 0 ? (
            completeTours.map((tour, index) => (
              <TourCard
                key={tour?.id || `completed-${index}`}
                tour={tour}
                upcoming={false}
              />
            ))
          ) : (
            <div className="col-12">
              <p className="text-muted">No completed tours available.</p>
            </div>
          )}
        </div>
      </div>
    </section>
  );
};

export default TravelTours;
